import axios from 'axios';

const BASE_URL = '/app/httpFunnel';

export const createHttpPost = async () => {
    const { data } = await axios.post(BASE_URL);

    return data;
};

export const getHttpPostConfig = async (fileBoxId) => {
    const { data: { baseUrl, params } } = await axios.post(`${BASE_URL}/async/${fileBoxId}`);

    return { baseUrl, params };
};

export const saveHttpPostConfig = async (fileBoxId, payload) => {
    const { data } = await axios.put(`${BASE_URL}/async/${fileBoxId}`, payload);

    return data;
};

export const saveHttpPostAuthorTest = async (fileBoxId, contactId) => {
    const { data } = await axios.post(`${BASE_URL}/${fileBoxId}/test`, JSON.stringify(contactId), {
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return data;
};

export const convertToRequest = async (funnelId, fileBoxId) => {
    const { data } = await axios.post(`/app/httpRequestFunnel/requests/${funnelId}/convertToRequest/${fileBoxId}`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return data;
};


export const saveCopyFromCampaign = async (fileBoxId, templateId) => {
    const { data } = await axios.put(`${BASE_URL}/${fileBoxId}/copyFrom`, JSON.stringify(templateId), {
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return data;
};

export const getAuthorsMenus = async () => {
    const { data } = await axios.get(`${BASE_URL}/async/authoringTestMenu`);

    return data;
};

export const getFilteredHttpPostCampaigns = async () => {
    const { data } = await axios.get(`${BASE_URL}/async/authoringCopyCampaign`);

    return data;
};

export const getHttpPostFunnel = async (payload) => {
    const {
        value,
        identifierName = 'style',
        identifierValue = 'http',
        idAttributeName = 'fileBoxId',
        idAttributeValue = null,
        filterAttributeName = null,
        filterAttributeValue = null,
        filterAttributeRequired = null,
    } = payload;

    const { data } = await axios.get(`${BASE_URL}/async/loadForFunnel?value=${value}&identifierName=${identifierName}&identifierValue=${identifierValue}&idAttributeName=${idAttributeName}&idAttributeValue=${idAttributeValue}&filterAttributeName=${filterAttributeName}&filterAttributeValue=${filterAttributeValue}&filterAttributeRequired=${filterAttributeRequired}`);

    return data;
};
